var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"writer-wrap"},[_c('textarea',{attrs:{"id":'editor' + _vm.uuid}},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }